import React, { useCallback, useEffect, useState } from "react";
import MainHeader from "../../../components/mainheader/MainHeaderNew";

import StickySidebar from "../../../components/stickysidebar/StickySidebar";
import MainFooter from "../../../components/mainfooter/MainFooter";
import { axiosInstance, REACT_APP_URL } from "../../../config";
import { fetchAboutUs } from "../../../redux/slices/aboutUsSlice";
import { useDispatch } from "react-redux";
import { toastError } from "../../../utils/reactToastify";
import { Link } from "react-router-dom";
import "./style.css";

const PrivacyPolicy = () => {
  const dispatch = useDispatch();
  const [headerImage, setHeaderImage] = useState({});
  const fetchRootCollection = useCallback(async () => {
    try {
      const { data } = await axiosInstance.get(
        `/api/header-image/title/PrivacyPolicy`
      );
      if (data?.success) {
        setHeaderImage(data?.data);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toastError(error?.response?.data?.message);
      } else {
        toastError(error?.message);
      }
    }
  }, []);
  useEffect(() => {
    fetchRootCollection();
  }, [fetchRootCollection]);
  useEffect(() => {
    dispatch(fetchAboutUs());
  }, [dispatch]);

  return (
    <div style={{ backgroundColor: "#dadada96" }}>
      <StickySidebar />
      <MainHeader isImageAvailable={headerImage?.pngImage ? true : false} />
      <div
        className="div"
        style={{
          height: headerImage?.pngImage ? "60vh" : "11vh",
          overflow: "hidden",
          position: "relative",
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.5)), url(${REACT_APP_URL}/images/header/${headerImage?.pngImage})`,
          backgroundSize: "cover",
        }}
      ></div>{" "}
      <div className="container py-3 policy-content">
        <h1 className="mb-4">Privacy Policy for Railingo Private Limited</h1>
        <p>
          <strong>Effective Date:</strong> April 1, 2025
        </p>

        <p>
          Welcome to <Link href="https://railingo.com/">www.railingo.com</Link>,
          the official website of Railingo Private Limited. We are committed to
          protecting the privacy of our website visitors, customers, and
          partners. This Privacy Policy explains how Railingo Private Limited
          ("Railingo," "we," "us," or "our") collects, uses, discloses, and
          protects your personal information when you visit our website, use our
          services, or interact with us.
        </p>

        <p>
          By accessing or using{" "}
          <Link href="https://railingo.com/">www.railingo.com</Link>, you agree
          to the terms of this Privacy Policy. If you do not agree with the
          terms of this Privacy Policy, please do not access or use our website.
        </p>

        <h4>1. Information We Collect</h4>
        <p>
          We collect various types of information for different purposes to
          provide and improve our services to you.
        </p>
        <h5>
          1.1. Personal Information (Information you provide to us directly)
        </h5>
        <p>
          This refers to information that can identify you as an individual. We
          may collect personal information when you:
        </p>
        <ul>
          <li>
            Fill out inquiry forms, contact forms, or request a quote (e.g.,
            name, email address, phone number, company name, address, project
            details).
          </li>
          <li>
            Sign up for newsletters, updates, or marketing communications.
          </li>
          <li>Request to book an appointment at our experience center.</li>
          <li>Participate in surveys or provide feedback.</li>
          <li>Communicate with us via email, phone, or online chat.</li>
          <li>Apply for a dealership or franchise opportunity.</li>
        </ul>

        <h5>1.2. Non-Personal Information (Automatically collected)</h5>
        <p>
          When you visit our website, we may automatically collect certain
          non-personal information through cookies, web beacons, and other
          tracking technologies. This information does not directly identify you
          but helps us understand your Browse behavior and improve our website
          functionality.
        </p>
        <p>This may include:</p>
        <ul>
          <li>IP address, browser type, OS, referring URLs</li>
          <li>Pages visited, time spent, timestamps, clickstream data</li>
        </ul>

        <h5>1.3. Information from Other Sources</h5>
        <p>
          We may receive information about you from third-party sources, such as
          business partners (e.g., if you inquire about our products through a
          partner website), or publicly available sources, and combine this with
          information we collect directly.
        </p>

        <h4>2. How We Use Your Information</h4>
        <p>We use the collected information for various purposes, including:</p>
        <ul>
          <li>
            To Provide Products and Services: To respond to your inquiries,
            provide quotes, process your requests for products or services, and
            fulfill orders.
          </li>
          <li>
            To Communicate with You: To send you updates, newsletters, marketing
            communications about our products, services, and promotions that may
            be of interest to you. You can opt-out of marketing communications
            at any time.
          </li>
          <li>
            To Improve Our Website and Services: To analyze website usage,
            troubleshoot problems, customize your experience, and improve the
            functionality and content of{" "}
            <Link href="https://railingo.com/">www.railingo.com</Link>, as well
            as the quality of our products and services.
          </li>
          <li>
            For Lead Generation and Sales: To connect you with our authorized
            dealers, distributors, or franchisees in your region who can assist
            you with your project requirements.
          </li>
          <li>
            For Marketing and Advertising: To deliver targeted advertisements
            and measure the effectiveness of our marketing campaigns.
          </li>
          <li>
            For Internal Operations: For data analysis, identifying usage
            trends, and determining the effectiveness of our promotional
            campaigns.
          </li>
          <li>
            For Security and Fraud Prevention: To protect our website, systems,
            and users from unauthorized access, fraud, and other illegal
            activities.
          </li>
          <li>
            For Legal Compliance: To comply with applicable laws, regulations,
            legal processes, and governmental requests.
          </li>
        </ul>

        <h4>3. How We Share Your Information</h4>
        <p>
          We may share your information with the following categories of
          recipients:
        </p>

        <ul>
          <li>
            Internal Teams: Your information may be shared within Railingo
            Private Limited with relevant departments (e.g., Sales, Marketing,
            Design, Operations, Customer Service) to process your requests and
            provide services.
          </li>
          <li>
            Authorized Dealers, Distributors, and Franchisees: To facilitate
            your inquiry or project, we may share your contact details and
            project requirements with our network of authorized dealers,
            distributors, and franchisees who operate in your geographical area.
            This is done to ensure you receive prompt and localized service.
          </li>
          <li>
            Third-Party Service Providers: We engage third-party companies and
            individuals to perform services on our behalf (e.g., website
            hosting, data analytics, email delivery, CRM services, marketing
            assistance, payment processing, technical support). These providers
            have access to your personal information only to perform their tasks
            on our behalf and are obligated not to disclose or use it for any
            other purpose.
          </li>
          <li>
            Business Transfers: In the event of a merger, acquisition,
            restructuring, sale of assets, or bankruptcy, your personal
            information may be transferred as part of the transaction.
          </li>
          <li>
            Legal Requirements and Law Enforcement: We may disclose your
            information if required to do so by law or in response to valid
            requests by public authorities (e.g., a court order, government
            agency).
          </li>
          <li>
            With Your Consent: We may share your information with third parties
            when we have your explicit consent to do so.
          </li>
        </ul>

        <h4>4. Data Security</h4>
        <p>
          We implement reasonable technical, administrative, and physical
          security measures to protect your personal information from
          unauthorized access, use, alteration, and disclosure. However, no
          method of transmission over the internet or method of electronic
          storage is 100% secure. Therefore, while we strive to use commercially
          acceptable means to protect your personal information, we cannot
          guarantee its absolute security.
        </p>

        <h4>5. Your Privacy Rights</h4>
        <p>
          As a user of{" "}
          <Link href="https://railingo.com/">www.railingo.com</Link>, you have
          certain rights regarding your personal information, subject to
          applicable law:
        </p>
        <ul>
          <li>
            Right to Access: You have the right to request a copy of the
            personal information we hold about you.
          </li>
          <li>
            Right to Correction/Rectification: You have the right to request
            that we correct any inaccurate or incomplete personal information we
            hold about you.
          </li>
          <li>
            Right to Erasure (Right to Be Forgotten): You may have the right to
            request the deletion of your personal information under certain
            circumstances.
          </li>
          <li>
            Right to Opt-Out of Marketing: You can opt-out of receiving
            marketing communications from us by following the unsubscribe
            instructions provided in our emails or by contacting us directly.
          </li>
          <li>
            Cookie Preferences: You can manage your cookie preferences through
            your browser settings.
          </li>
          <li>
            To exercise any of these rights, please contact us using the contact
            details provided below.
          </li>
        </ul>

        <h4>6. Cookies and Tracking Technologies</h4>
        <p>
          We use cookies and web beacons to enhance user experience. You may
          disable cookies via browser settings, but it may limit some
          functionalities.
        </p>

        <ul>
          <li>
            Cookies: Small data files stored on your device that help us
            remember your preferences, understand how you interact with our
            website, and provide a more personalized experience.
          </li>
          <li>
            Web Beacons/Pixels: Electronic files used to count users who have
            visited certain pages or opened emails, and for other related
            website statistics.
          </li>
          <li>
            You have the option to accept or refuse cookies. Most web browsers
            automatically accept cookies, but you can usually modify your
            browser setting to decline cookies if you prefer. However, this may
            prevent you from taking full advantage of the website.
          </li>
        </ul>

        <h4>7. Third-Party Links</h4>
        <p>
          Our site may contain links to third-party websites. We are not Our
          website may contain links to websites operated by third parties.
          Please note that this Privacy Policy applies only to{" "}
          <Link href="https://railingo.com/">www.railingo.com</Link>. We are not
          responsible for the privacy practices of third-party websites. We
          encourage you to review the privacy policies of any third-party
          websites you visit.
        </p>

        <h4>8. Children's Privacy</h4>
        <p>
          Our website is not intended for individuals under the age of 18. We do
          not knowingly collect personal information from children under 18. If
          we become aware that we have collected personal information from a
          child under 18 without parental consent, we will take steps to remove
          that information from our servers.
        </p>

        <h4>9. Changes to This Privacy Policy</h4>
        <p>
          We may update our Privacy Policy from time to time. We will notify you
          of any changes by posting the new Privacy Policy on this page and
          updating the "Effective Date" at the top of this Privacy Policy. We
          encourage you to review this Privacy Policy periodically for any
          changes. Your continued use of the website after any modifications to
          this Privacy Policy will constitute your acknowledgment of the
          modifications and your consent to abide and be bound by the modified
          Privacy Policy.
        </p>

        <h4>10. Contact Us</h4>
        <p>
          If you have any questions about this Privacy Policy, our data
          practices, or if you wish to exercise your privacy rights, please
          contact us:
        </p>
        <address>
          <strong>Railingo Private Limited</strong>
          <br />
          Plot no. 149, Sector 4, IMT Manesar,
          <br />
          Gurugram, Haryana - 122051
          <br />
          <strong>Email:</strong>{" "}
          <a href="mailto:sales@railingo.com">sales@railingo.com</a>
          <br />
          <strong>Phone:</strong> +91 8755999395
        </address>
      </div>
      <MainFooter />
    </div>
  );
};

export default PrivacyPolicy;
